module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/img_title_nagai_hiratsuka-b985a3f9cad833a121c556d6cd7f9f3d.jpg";